module.exports = __webpack_public_path__ + "img/juca_dillingen.b59eedb5.jpg";